<div [formGroup]="group">
  <app-inner-form-element-navigation-board
      [id]="uniqueComponentId('navigationboard-')"
      [formControlName]="config?.name"
      [config]="config"
      [group]="group"
      #formInput>
  </app-inner-form-element-navigation-board>
</div>
